import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const AnnouncementManagementPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchItems = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/announcements');
      setItems(res.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  if (loading) return <p>Loading announcements...</p>;
  if (error) return <p className="text-red-500">Error: {error}</p>;

  return (
    <div className="p-6">
      <h1 className="text-2xl mb-4">Announcements</h1>
      <Link to="/dashboard/admin/announcement/new" className="text-blue-500">+ New Announcement</Link>
      <table className="min-w-full mt-4 border">
        <thead>
          <tr>
            <th className="border p-2">Title</th>
            <th className="border p-2">Start Date</th>
            <th className="border p-2">End Date</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map(a => (
            <tr key={a.id}>
              <td className="border p-2">{a.title}</td>
              <td className="border p-2">{a.startDate ? new Date(a.startDate).toLocaleDateString() : '-'}</td>
              <td className="border p-2">{a.endDate ? new Date(a.endDate).toLocaleDateString() : '-'}</td>
              <td className="border p-2">
                <Link to={`/dashboard/admin/announcement/${a.id}/edit`} className="text-green-500 mr-2">Edit</Link>
                <button
                  onClick={async () => {
                    if (window.confirm('Delete this announcement?')) {
                      try {
                        await axios.delete(`/api/announcements/${a.id}`);
                        fetchItems();
                      } catch (err) {
                        alert(err.response?.data?.error || 'Delete failed');
                      }
                    }
                  }}
                  className="text-red-500"
                >Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AnnouncementManagementPage;
